import React from 'react'
import Sidebar from '../sidebar/sidebar'
import image from "../../assets/Large-screens/aboutus.png"

const visionndmission = () => {
  return (
   <>
    <>
      <div className="home-container">
        <Sidebar />
        <div className="home-content">
          <img src={image} alt="example" className="home-image" />
        </div>
      </div>
    </>
   </>
  )
}

export default visionndmission